export const TatType = [
    { value: '', label: '-Select-', isDisabled: true },
    { value: 'daily', label: 'Daily' },
    { value: 'hourly', label: 'Hourly' },
    { value: 'before-estimated', label: 'Before Estimated' },
]
export const TaskPriority = [
    { 'id': 1, "title": "Urgent" },
    { 'id': 2, "title": "High" },
    { 'id': 3, "title": "Normal" },
    { 'id': 4, "title": "Low" }
]
export const TaskMode = [
    { 'id': 1, "title": "Yearly" },
    { 'id': 2, "title": "Halfyearly" },
    { 'id': 3, "title": "Quarterly" },
    { 'id': 4, "title": "Last Date of Every Month" },
    { 'id': 5, "title": "Monthly" },
    { 'id': 6, "title": "Weekly" },
    { 'id': 7, "title": "Daily" },
    { 'id': 8, "title": "Custom" },
    // { 'id': 8, "title": "Biweekly(15 days)" },
    // { 'id': 9, "title": "Twice a Week(3 day)" },
    // { 'id': 10, "title": "Thrice a Week( 2 day)" }
]
export const TaskStatus = [
    { 'id': 1, "title": "Open" },
    { 'id': 2, "title": "In Progress" },
    { 'id': 3, "title": "Done" },
    { 'id': 4, "title": "Closed" }
]

export const CurrencyList = [
    { code: 'USD', symbol: '$', name: 'US Dollar', placeholder: '0.00' },
    { code: 'INR', symbol: '₹', name: 'Indian Rupee', placeholder: '0.00' },
    { code: 'EUR', symbol: '€', name: 'Euro', placeholder: '0.00' },
    { code: 'GBP', symbol: '£', name: 'British Pound', placeholder: '0.00' },
    { code: 'JPY', symbol: '¥', name: 'Japanese Yen', placeholder: '0' },
    { code: 'CAD', symbol: '$', name: 'Canadian Dollar', placeholder: '0.00' },
    { code: 'AUD', symbol: '$', name: 'Australian Dollar', placeholder: '0.00' },
    { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc', placeholder: '0.00' },
    { code: 'CNY', symbol: '¥', name: 'Chinese Yuan', placeholder: '0.00' },
    { code: 'SGD', symbol: '$', name: 'Singapore Dollar', placeholder: '0.00' },
    { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', placeholder: '0.00' },
    { code: 'SAR', symbol: '﷼', name: 'Saudi Riyal', placeholder: '0.00' }
]